import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const ProductDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    // FIX: Live domain use karein
    const BASE_URL = "https://rbmchemicals.com";
    const API_URL = `${BASE_URL}/api/get_product_detail/${id}/`;

    useEffect(() => {
        if (!id) return;

        setLoading(true);
        fetch(API_URL)
            .then((res) => {
                if (!res.ok) throw new Error('Product not found');
                return res.json();
            })
            .then((data) => {
                setProduct(data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Fetch Error:", err);
                setLoading(false);
            });
    }, [id, API_URL]);

    if (loading) return <div className="py-20 text-center text-xl">Loading product details...</div>;
    if (!product) return <div className="py-20 text-center text-xl text-red-600">Product not found!</div>;

    return (
        <div className="min-h-screen bg-gray-50">
            <div
                className="relative h-[300px] w-full flex items-center justify-center bg-cover bg-center"
                style={{ backgroundImage: "url('/assets/banner.jpg')" }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase tracking-wider text-center px-4">
                    {product.title}
                </h1>
            </div>

            <div className="py-16 px-10 container mx-auto">
                <div className="flex flex-col md:flex-row gap-12 bg-white p-8 rounded-lg shadow-md mb-10">
                    <div className="w-full md:w-1/2">
                        <img
                            // FIX: BASE_URL dynamic hai ab
                            src={product.image.startsWith('http') ? product.image : `${BASE_URL}${product.image}`}
                            alt={product.title}
                            className="w-full h-auto rounded-lg shadow-lg object-cover"
                            onError={(e) => { e.target.src = 'https://via.placeholder.com/400'; }}
                        />
                    </div>
                    <div className="w-full md:w-1/2">
                        <h3 className="font-bold text-gray-800 text-xl mb-3 border-b pb-2">Description:</h3>
                        <p className="text-gray-600 text-lg leading-relaxed mb-6">{product.description}</p>
                        <button
                            onClick={() => navigate('/enquiry')}
                            className="bg-blue-900 text-white px-10 py-4 rounded-lg font-bold hover:bg-orange-600 transition"
                        >
                            Enquire Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;